import { Injectable } from '@angular/core';
import { cloneDeep, isEqual, omit } from 'lodash';

interface IFormConfigItem {
  formId: string;
  formRefName: string;
  referencePath: any;
  itemOrderIndex: number;
}

const attr_OrderIndex: string = 'itemOrderIndex';

@Injectable()
export class ItemSelectionService {
  public map: any = { };
  public nextIterationItems: any = [];

  constructor() {
  }

  getGrouppedDataStructure(totalSelectedItemList) {
    const outObject = totalSelectedItemList.reduce(function(a, b) {
      if (b) {
        const estKey = b['itemReferences'].length > 0 ? (b['itemReferences'][0].reference): null;
        (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(b);
        return a;
      }
    }, { });
    return outObject;
  }

  createTreeStructure(itemsData, form, datamodelKeys) {
    let data: Array<item> = [];
    data = itemsData;
    let itemMap = new Map<string, string>();
    data.forEach(item => {
      item['itemId'] = item[datamodelKeys['itemId']];
      item['itemName'] = item[datamodelKeys['itemName']];
      item['itemReferences'] = item[datamodelKeys['itemReferences']].references;
      itemMap.set(item['itemId'], item['itemName']);
    });

    let node, i, roots = [];
    this.nextIterationItems = [];

    let formNode: IFormConfigItem;
    if (form && form.payload.formsConfig) {
      formNode = form.payload.formsConfig;
      let formReferenceNames = omit(formNode, '$$');
      formReferenceNames = cloneDeep(formReferenceNames);

      for (const key in formReferenceNames) {
        if (formReferenceNames.hasOwnProperty(key)) {
          const reference = key.split('___');

          formNode[key][datamodelKeys['itemReferences']] = {};
          formNode[key][datamodelKeys['itemReferences']].references = [];
          formNode[key]['itemReferences'] = formNode[key][datamodelKeys['itemReferences']].references;

          const referencePath = [];
          if (reference.length === 1) {
            formNode[key]['formRefName'] = reference[reference.length - 1];
            formNode[key]['referencePath'] = [];
          }
          for (let i = 0; i < reference.length - 1; i++) {
            let display = reference[i];
            if (itemMap.has(reference[i])) {
              display = itemMap.get(reference[i]);
            }
            referencePath.push({'reference': reference[i], 'display': display});
            formNode[key]['referencePath'] = referencePath;
            formNode[key]['formRefName'] = reference[reference.length - 1];
          }
        }
      }
    }

    for (i = 0; i < data.length; i += 1) {
      this.map[data[i].itemId] = i;
      data[i].list = [];
      node = data[i];
      node.nodeType = 'item';

      if (node.itemReferences && node.itemReferences.length === 0) {
        node.referencePath = node.itemReferences;
        roots.push(node);
        node = this.pushFormToNode(formNode, node);
      }
      else {
        this.nextIterationItems.push(node);
      }
    }

    roots.forEach(rootItem => {
      this.nextIterationItems.forEach((childItem) => {
        if (rootItem.itemId === childItem.itemReferences[0].reference) {
          this.allNodesTreeFormat(childItem, rootItem, formNode, roots);
          this.nextIterationItems.forEach((item) => {
            if (childItem.itemId === item.itemReferences[0].reference) {
              this.allNodesTreeFormat(item, childItem, formNode, this.nextIterationItems,
                rootItem.itemId, rootItem.itemName);
            }
          });
        }
      });
    });

    return roots;
  }

  allNodesTreeFormat(node, data, formNode, parentNodes, itemRef?, itemName?) {
    let nodeItem;
    if (node.itemReferences && node.itemReferences.length !== 0 && node.itemReferences[0].reference !== undefined) {

      if (node.itemReferences[0].reference && data.list == undefined) {
        data.list = [];
      }
      const references = this.getParentReference(parentNodes, node.itemReferences[0].reference);
      if (itemRef) {
        references.unshift({ reference: itemRef, display : itemName});
      }
      node.referencePath = references;
      data.list.push(node);
      nodeItem = this.pushFormToNode(formNode, node, data);
    }
    return nodeItem;
  }

  pushFormToNode(formNode, node, parentNode?) {

    let matchedKey;
    for (const key in formNode) {
      if (formNode.hasOwnProperty(key)) {
        if (node.referencePath) {
          if (isEqual(formNode[key].referencePath, node.referencePath) && formNode[key].formRefName === node.itemId) {
            matchedKey = key;
            break;
          }
        } else if (formNode[key].formRefName === node.itemId) {
          matchedKey = key;
          break;
        }

      }
    }

    // if matched key was found:
    if (!!matchedKey) {

      if(node['data']) {
        formNode[matchedKey]['data'] = node['data'];
        formNode[matchedKey]['subType'] = node['subType'];
      }
      formNode[matchedKey].list = [];
      formNode[matchedKey].nodeType = 'form';
      node.list.push(formNode[matchedKey]);

      // if form's configuration has an attribute to set a specific sort index - copy it to the parent node's data
      if (!parentNode) parentNode = node;

      if (formNode[matchedKey].hasOwnProperty(attr_OrderIndex) &&
          ! parentNode.hasOwnProperty(attr_OrderIndex)) {

        parentNode[attr_OrderIndex] = formNode[matchedKey][attr_OrderIndex];
      }

    }

    return node;
  }

  getParentReference(data, item) {
    let referenceArray;
    data.some(items => {
      let reference;
      const refObj = [{ 'reference' : item, 'display' : items.itemName}];
      if (items.itemId === item) {
        return referenceArray = refObj;
      }
      reference = this.getParentReference(items.list || [], refObj);
      if (reference) {
        const refObj = [{ 'reference' : items.itemId, 'display' : items.itemName}, ...reference];
        return referenceArray = refObj;
      }
    });
    return referenceArray;
  }

}

interface item {
  itemId: string;
  itemName: string;
  itemReferences: any;
  referencePath: any;
  nodeType: string;
  list: any;
}
